import { render, staticRenderFns } from "./SecondSection.vue?vue&type=template&id=699e63b4&scoped=true&"
import script from "./SecondSection.vue?vue&type=script&lang=js&"
export * from "./SecondSection.vue?vue&type=script&lang=js&"
import style0 from "./SecondSection.vue?vue&type=style&index=0&id=699e63b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699e63b4",
  null
  
)

export default component.exports